import { graphql, useFragment } from "react-relay";

import { FilterButton } from "arkh";
import React from "react";
import {
  TodoTagButtonActiveContent,
  TodoTagButtonInactiveContent,
} from "../TodoToolbar/TodoTagButtonContent";

import { TodoTagsDialog } from "../TodoDialogs/TodoTagsDialog";
import { FilterButtonTodoTags_tags$key } from "./__generated__/FilterButtonTodoTags_tags.graphql";

export function FilterButtonTodoTags(props: {
  tags: FilterButtonTodoTags_tags$key;
  selectedTagIds: string[];
  setSelectedTagIds: (tagIds: string[]) => void;
}) {
  const tags = useFragment(
    graphql`
      fragment FilterButtonTodoTags_tags on TodoCategoryTag
      @relay(plural: true) {
        color
        id
        title
        ...TodoTagButtonContentActive_todoCategoryTag
      }
    `,
    props.tags
  );
  const [isOpen, setIsOpen] = React.useState(false);

  const selectedTags = tags.filter((tag) =>
    props.selectedTagIds.includes(tag.id)
  );
  const dialog = (
    <TodoTagsDialog
      categoryTags={tags}
      onClose={() => {
        setIsOpen(false);
      }}
      selectedTagIds={props.selectedTagIds}
      setSelectedTagIds={props.setSelectedTagIds}
      visible={isOpen}
    />
  );
  if (tags.length === 0) {
    return null;
  }
  if (selectedTags.length === 0) {
    return (
      <>
        <FilterButton
          mode="inactive"
          onPress={() => {
            setIsOpen(true);
          }}
          indicatorIcon="tag"
        >
          <TodoTagButtonInactiveContent />
        </FilterButton>
        {dialog}
      </>
    );
  }
  return (
    <>
      <FilterButton
        mode="active"
        onPress={() => {
          setIsOpen(true);
        }}
        isPlural={true}
      >
        <TodoTagButtonActiveContent tags={selectedTags} />
      </FilterButton>
      {dialog}
    </>
  );
}
